const config = {
  url: process.env.NEXT_PUBLIC_UNLEASH_SERVER_API_URL,
  clientKey: process.env.NEXT_PUBLIC_UNLEASH_CLIENT_KEY,
  refreshInterval: 0,
  appName: process.env.NEXT_PUBLIC_UNLEASH_ENVIRONMENT,
}

export default config
